import React  from 'react';
import { DatePicker } from '@material-ui/pickers';
import { makeStyles } from '@material-ui/styles';
import EventIcon from "@material-ui/icons/Event";

const useStyles = makeStyles(theme => ({
  dateContainer: {
    flex: 1,
    '& .MuiInputBase-root': {
      cursor: 'pointer',
    },
  },
  datePicker: {
    fontSize: 14,
    '& .MuiInput-input:not(.Mui-disabled)': {
      fontSize: 14,
      cursor: 'pointer',
      color: theme.palette.text.secondary,
    }
  },

  icon: {
    marginRight: 8,
  }
}));

const DatePickerLabel = ({ onChange, value, emptyLabel, ...other }) => {
  const classes = useStyles();
  return (
    <div className={classes.dateContainer}>
      <DatePicker
        {...other}
        inputVariant="standard"
        className={classes.datePicker}
        emptyLabel={emptyLabel || "Select date"}
        format="LL"
        value={value || null}
        onChange={onChange}
        InputProps={{
          disableUnderline: true,
          size: 'small',
          startAdornment: (
            <EventIcon fontSize="small" className={classes.icon} color="disabled" />
          )
        }}
      />
    </div>
  )
};

export default DatePickerLabel;
